import axios from 'axios';
import FaceCollectorModel from '../../models/FaceCollectorModel';
import apiService from '../apiService';

export default async function getByEventId(eventId = '', system = '') {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}faceScanConfig/getByEventId?eventId=${eventId}&system=${system}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return FaceCollectorModel(_ret.data.data);
  } catch (error) {
    console.log('Error getByEventId', error);
    throw error;
  }
}
